import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import QuotesAdmin from "@/pages/admin/QuotesAdmin";
import FleetAdmin from "@/pages/admin/FleetAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import RoutesAdmin from "@/pages/admin/RoutesAdmin";
import AeropuertoTours from "@/pages/site/AeropuertoTours";
import TransporteColombia from "@/pages/site/TransporteColombia";
import RutasPage from "@/pages/site/Rutas";
import Nosotros from "@/pages/site/Nosotros";
import Cotizar from "@/pages/site/Cotizar";
import Contacto from "@/pages/site/Contacto";
import FAQ from "@/pages/site/FAQ";
import NotFound from "@/pages/NotFound";
import BlogIndex from "@/pages/blog/BlogIndex";
import BlogPost from "@/pages/blog/BlogPost";
import ServicePage from "@/pages/site/ServicePage";

function Protected({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0908] text-[#E8C87A] font-display text-xl">
      Cargando…
    </div>
  );
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/servicios/aeropuerto-y-tours" element={<AeropuertoTours />} />
          <Route path="/servicios/transporte-turistico-colombia" element={<TransporteColombia />} />
          <Route path="/servicios/rutas" element={<RutasPage />} />
          <Route path="/servicios/:slug" element={<ServicePage />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/cotizar" element={<Cotizar />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="cotizaciones" element={<QuotesAdmin />} />
            <Route path="flota" element={<FleetAdmin />} />
            <Route path="testimonios" element={<TestimonialsAdmin />} />
            <Route path="rutas" element={<RoutesAdmin />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;